<template>
    <cus-dialog-no-drag class="table-h360"
        :title="title"
        :data="item"
        width="80%"
        :visible.sync="visibleSync"
        :close-on-click-modal="false"
        :footerVisible="footerVisible"
        @confirm="addRecordToList">
        <el-container style="padding: 10px 0px 5px 0px;user-select: auto;">
            <el-aside width="65%" style="padding-right: 5px;height: 510px;">
                <cus-form ref="record-info" :data="recordInfo" :columns="recordColumnList" @confirm="putRecordInfo"></cus-form>
            </el-aside>
            <el-main style="height: 510px;">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="管路" name="1">
                        <ListView :tableHeight="tubeHeight" ref="tube-item" :showSequence="false" :rowNoStyle="true" :datalist="tubeItems" :columns="tubeColumns" @extrabutton-click="ExtraButtonClick"></ListView>
                    </el-collapse-item>
                    <el-collapse-item title="入量-临床用药" name="2">
                        <ListView :tableHeight="inDrugHeight" ref="in-item" :showSequence="false" :rowNoStyle="true" :datalist="inDrugItems" :columns="inDrugColumns" @extrabutton-click="ExtraButtonClick"></ListView>
                    </el-collapse-item>
                    <el-collapse-item title="入量-胃肠" name="3">
                        <ListView :tableHeight="inOtherHeight" ref="in-item" :showSequence="false" :rowNoStyle="true" :datalist="inOtherItems" :columns="inOtherColumns" @extrabutton-click="ExtraButtonClick"></ListView>
                    </el-collapse-item>
                    <el-collapse-item title="出量" name="4">
                        <ListView :tableHeight="outHeight" ref="out-item" :showSequence="false" :rowNoStyle="true" :datalist="outItems" :columns="outColumns" @extrabutton-click="ExtraButtonClick"></ListView>
                    </el-collapse-item>
                </el-collapse>
            </el-main>
        </el-container>
    </cus-dialog-no-drag>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AddRecord`,
    props: {
        visible: { type: Boolean },
        continueAdd: { type: Boolean },
        data: { type: Object },
        title: { type: String },
        footerVisible: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            surgeryId: undefined,
            recordId: undefined,
            recordInfo: {},
            tubeItems: [],
            inDrugItems: [],
            inOtherItems: [],
            outItems: [],
            activeNames: [`1`, `2`, `3`, `4`],
            item: {
                record_items: [{
                    is_empty: true
                }]
            },
            RecordTmps: [],
            removeItems: []
        }
    },
    created() {
        this.getTmp()
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `screenHeight`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `currentUser`, `currentSurgery`, `sys_enums`, `enum_region_type`, `active_ward`, `sysuser/workers_by_duty`]),
        recordColumnList() {
            let me = this
            let edit = !me.isHavePermissions(`edit`)
            return [
                {
                    type: `datetime`,
                    prop: `record_time`,
                    label: `日期时间`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row, index }) => {
                        let req = this.myaxios.get(`/api/Nursing/NursingRecord/GetVitalSign?surgeryId=${me.surgeryId}&recordTime=${row.record_time}`)
                        req.then(data => {
                            this.$set(row, `vital_sign_t`, data && data.vital_sign_t)
                            this.$set(row, `vital_sign_p`, data && data.vital_sign_p)
                            this.$set(row, `vital_sign_r`, data && data.vital_sign_r)
                            this.$set(row, `vital_sign_bp`, data && data.vital_sign_bp)
                        })
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `nurse`,
                    label: `记录护士`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    options: `/api/AcisSystem/Worker/SearchForKey`,
                    default: me.currentUser && {
                        value: me.currentUser.dic_worker_id,
                        label: me.currentUser.dic_worker_name
                    },
                    colspan: 12,
                    change: (that, { row, index }) => {
                        this.$set(row, `nurse_id`, row.nurse && row.nurse.value)
                        this.$set(row, `nurse_name`, row.nurse && row.nurse.label)
                    }
                },
                {
                    type: `divider`,
                    prop: `title1`,
                    placeholder: `生命体征`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `string`,
                    prop: `vital_sign_t`,
                    label: `T(℃)`,
                    readonly: edit,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_p`,
                    label: `P(次/分)`,
                    readonly: edit,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_r`,
                    label: `R(次/分)`,
                    readonly: edit,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `vital_sign_bp`,
                    label: `BP(mmHg)`,
                    readonly: edit,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `divider`,
                    prop: `title2`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: ``,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `string`,
                    prop: `pain_score`,
                    label: `疼痛评分`,
                    readonly: edit,
                    colspan: 12,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `select`,
                    prop: `enum_consciousness_state`,
                    label: `意识状态`,
                    readonly: edit,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: this.sys_enums.Enum_ConsciousnessState || []
                },
                // {
                //     type: `divider`,
                //     prop: `title3`,
                //     isCreatable: true,
                //     isEditable: true,
                //     placeholder: ``,
                //     colspan: 24,
                //     label: { content: ` `, position: `top` }
                // },
                {
                    type: `string`,
                    prop: `left_pupil_size`,
                    label: `左 瞳 孔（mm）`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_light_reflection_left`,
                    label: `光反射`,
                    options: this.sys_enums.Enum_LightReflection || [],
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `right_pupil_size`,
                    label: `右 瞳 孔（mm）`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_light_reflection_right`,
                    label: `光反射`,
                    options: this.sys_enums.Enum_LightReflection || [],
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 6
                },
                // {
                //     type: `divider`,
                //     prop: `title4`,
                //     isCreatable: true,
                //     isEditable: true,
                //     placeholder: ``,
                //     colspan: 24,
                //     label: { content: ` `, position: `top` }
                // },
                {
                    type: `string`,
                    prop: `oxygen_uptake`,
                    label: `吸氧(L/min)`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `pulse_oxygen_saturation`,
                    label: `SPO2(%)`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `skin_condition`,
                    label: `受压皮肤情况`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_nursing_measures`,
                    label: `基础护理措施`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    options: this.sys_enums.Enum_NursingMeasures || [],
                    colspan: 12
                },
                // {
                //     type: `divider`,
                //     prop: `title5`,
                //     isCreatable: true,
                //     isEditable: true,
                //     placeholder: ``,
                //     colspan: 24,
                //     label: { content: ` `, position: `top` }
                // },
                {
                    type: `select`,
                    prop: `notes_tmp`,
                    label: `病情观察及措施`,
                    isCreatable: edit,
                    isEditable: edit,
                    readonly: edit,
                    options: me.RecordTmps || [],
                    colspan: 24,
                    change: (that, { row, area }) => {
                        if (row.notes_tmp && row.notes_tmp) {
                            let tmp = _.find(me.RecordTmps, d => d.value == row.notes_tmp)
                            if (tmp) {
                                row.notes = tmp.label
                            }
                            row.notes_tmp = null
                        }
                    }
                },
                {
                    type: `textarea1`,
                    prop: `notes`,
                    label: ``,
                    isCreatable: true,
                    isEditable: true,
                    readonly: edit,
                    config: {
                        minRows: 4
                    },
                    colspan: 24
                }
            ]
        },
        tubeColumns() {
            let me = this
            let edit = !me.isHavePermissions(`edit`)
            let list = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `select`,
                    prop: `item_name`,
                    label: `名称`,
                    isListable: true,
                    readonly: edit,
                    allowCreate: true,
                    options: _.map(this.sys_enums.Enum_TubeName || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    change: (that, { row, index }) => {
                        let lastrow = me.tubeItems[me.tubeItems.length - 1]
                        if (lastrow && lastrow.item_name && me.isHavePermissions(`add`)) {
                            me.tubeItems.push({ ___index: _.now(), active: true })
                        }
                        if (!row.item_name && me.tubeItems[index + 1]) {
                            if (!me.tubeItems[index + 1].item_name) {
                                me.tubeItems.splice(index + 1, 1)
                            }
                            // else {
                            //     me.tubeItems.splice(index, 1)
                            // }
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `description`,
                    label: `通畅`,
                    width: `100`,
                    options: _.map(this.sys_enums.Enum_TubeDescription || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    isListable: true,
                    readonly: edit
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `80`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.item_name && me.isHavePermissions(`delete`)) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeTubeItem`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            return list
        },
        tubeHeight() {
            return ((this.tubeItems && this.tubeItems.length || 1) * 42) + 45
        },
        inDrugColumns() {
            let me = this
            let edit = !me.isHavePermissions(`edit`)
            let list = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `string`,
                    prop: `item_name`,
                    label: `项目`,
                    readonly: edit,
                    isListable: true,
                    change: (that, { row, index }) => {
                        let lastrow = me.inDrugItems[me.inDrugItems.length - 1]
                        if (lastrow && lastrow.item_name && me.isHavePermissions(`add`)) {
                            me.inDrugItems.push({ ___index: _.now(), active: true })
                        }
                        if (!row.item_name && me.inDrugItems[index + 1]) {
                            if (!me.inDrugItems[index + 1].item_name) {
                                me.inDrugItems.splice(index + 1, 1)
                            }
                        }
                    }
                },
                {
                    type: `float`,
                    prop: `dose`,
                    label: `量(ml)`,
                    width: `80`,
                    isListable: true,
                    readonly: edit
                },
                {
                    type: `select`,
                    prop: `add_way`,
                    label: `途径`,
                    width: `80`,
                    isListable: true,
                    options: _.map(this.sys_enums.Enum_AddWay || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    readonly: edit
                },
                {
                    type: `select`,
                    prop: `speed`,
                    label: `流速`,
                    width: `70`,
                    allowCreate: true,
                    options: _.map(this.sys_enums.Enum_DrugSpeed || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    isListable: true,
                    readonly: edit
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `80`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.item_name && me.isHavePermissions(`delete`)) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeInDrugItem`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            return list
        },
        inDrugHeight() {
            return ((this.inDrugItems && this.inDrugItems.length || 1) * 42) + 45
        },
        inOtherColumns() {
            let me = this
            let edit = !me.isHavePermissions(`edit`)
            let list = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `select`,
                    prop: `item_name`,
                    label: `项目`,
                    isListable: true,
                    readonly: edit,
                    allowCreate: true,
                    options: _.map(this.sys_enums.Enum_InStomach || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    change: (that, { row, index }) => {
                        let lastrow = me.inOtherItems[me.inOtherItems.length - 1]
                        if (lastrow && lastrow.item_name && me.isHavePermissions(`add`)) {
                            me.inOtherItems.push({ ___index: _.now(), active: true })
                        }
                        if (!row.item_name && me.inOtherItems[index + 1]) {
                            if (!me.inOtherItems[index + 1].item_name) {
                                me.inOtherItems.splice(index + 1, 1)
                            }
                            // else {
                            //     me.inOtherItems.splice(index, 1)
                            // }
                        }
                    }
                },
                {
                    type: `float`,
                    prop: `dose`,
                    label: `量(ml)`,
                    width: `80`,
                    isListable: true,
                    readonly: edit
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `80`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.item_name && me.isHavePermissions(`delete`)) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeInOtherItem`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            return list
        },
        inOtherHeight() {
            return ((this.inOtherItems && this.inOtherItems.length || 1) * 42) + 45
        },
        outColumns() {
            let me = this
            let edit = !me.isHavePermissions(`edit`)
            let list = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `select`,
                    prop: `item_name`,
                    label: `项目`,
                    isListable: true,
                    readonly: edit,
                    allowCreate: true,
                    options: _.map(this.sys_enums.Enum_OutItemName || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    change: (that, { row, index }) => {
                        let lastrow = me.outItems[me.outItems.length - 1]
                        if (lastrow && lastrow.item_name && me.isHavePermissions(`add`)) {
                            me.outItems.push({ ___index: _.now(), active: true })
                        }
                        if (!row.item_name && me.inOtherItems[index + 1]) {
                            if (!me.inOtherItems[index + 1].item_name) {
                                me.inOtherItems.splice(index + 1, 1)
                            }
                            // else {
                            //     me.inOtherItems.splice(index, 1)
                            // }
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `description`,
                    label: `颜色性状`,
                    width: `100`,
                    isListable: true,
                    allowCreate: true,
                    options: _.map(this.sys_enums.Enum_OutColorCharacteristics || [], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    readonly: edit
                },
                {
                    type: `float`,
                    prop: `dose`,
                    label: `出量(ml)`,
                    width: `100`,
                    isListable: true,
                    readonly: edit
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `80`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.item_name && me.isHavePermissions(`delete`)) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeOutItem`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            return list
        },
        outHeight() {
            return ((this.outItems && this.outItems.length || 1) * 42) + 45
        },
        visibleSync: {
            get: function() {
                if (this.visible) {
                    this.loadOne()
                }
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        getTmp() {
            this.myaxios.get(`/api/Nursing/NursingRecord/Search`).then(data => {
                this.RecordTmps = data || []
            })
        },
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `nursing_record:${permiskey}`) != -1
        },
        handleChange(val) {
            console.log(val)
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        loadOne() {
            let that = this
            that.surgeryId = that.data.biz_surgery_info_id
            that.recordId = that.data.biz_nursing_record_id
            that.recordInfo = {}
            if (that.data && that.data.record_time) {
                let recordTime = this.$moment(that.data.record_time).format(`YYYY/MM/DD HH:mm`)
                this.myaxios
                    .get(`/api/Nursing/NursingRecord/GetSurgeryRecordInfo?surgeryId=${that.surgeryId}&recordTime=${recordTime}`)
                    .then(data => {
                        if (data && data.record_time) {
                            that.recordInfo = data
                            that.tubeItems = data.tubeItems && _.map(
                                data.tubeItems,
                                (d, index) => {
                                    return {
                                        ...d,
                                        ___index: index
                                    }
                                }
                            ) || []
                            that.inDrugItems = data.inDrugItems && _.map(
                                data.inDrugItems,
                                (d, index) => {
                                    return {
                                        ...d,
                                        ___index: index
                                    }
                                }
                            ) || []
                            that.inOtherItems = data.inOtherItems && _.map(
                                data.inOtherItems,
                                (d, index) => {
                                    return {
                                        ...d,
                                        ___index: index
                                    }
                                }
                            ) || []
                            that.outItems = data.outItems && _.map(
                                data.outItems,
                                (d, index) => {
                                    return {
                                        ...d,
                                        ___index: index
                                    }
                                }
                            ) || []
                        }
                        if (that.isHavePermissions(`edit`)) {
                            that.tubeItems.push({ ___index: _.now(), active: true })
                            that.inDrugItems.push({ ___index: _.now(), active: true })
                            that.inOtherItems.push({ ___index: _.now(), active: true })
                            that.outItems.push({ ___index: _.now(), active: true })
                        }
                    })
                    .catch(e => { console.log(e) })
            } else {
                if (that.isHavePermissions(`add`)) {
                    that.tubeItems = [{ ___index: _.now(), active: true }]
                    that.inDrugItems = [{ ___index: _.now(), active: true }]
                    that.inOtherItems = [{ ___index: _.now(), active: true }]
                    that.outItems = [{ ___index: _.now(), active: true }]
                }
            }
        },
        removeTubeItem({ row, index }) {
            this.tubeItems.splice(index, 1)
        },
        removeInDrugItem({ row, index }) {
            this.inDrugItems.splice(index, 1)
        },
        removeInOtherItem({ row, index }) {
            this.inOtherItems.splice(index, 1)
        },
        removeOutItem({ row, index }) {
            this.outItems.splice(index, 1)
        },
        addRecordToList() {
            let that = this
            that.$refs[`record-info`].confirm()
        },
        putRecordInfo(data) {
            let that = this
            return new Promise(resolve => {
                that.recordInfo = data
                if (that.recordInfo.nurse && !that.recordInfo.nurse_id) {
                    that.recordInfo.nurse_id = that.recordInfo.nurse.value
                    that.recordInfo.nurse_name = that.recordInfo.nurse.label
                }
                that.recordInfo.record_time = this.$moment(data.record_time).format(`YYYY/MM/DD HH:mm`)
                that.recordInfo.tubeItems = _.map(
                    _.filter(that.tubeItems, d => d.item_name),
                    (d, index) => {
                        return {
                            ...d,
                            biz_nursing_record_id: that.recordInfo.id,
                            item_type: `导管`,
                            display_order: index + 1
                        }
                    }
                ) || []
                that.recordInfo.inDrugItems = _.map(
                    _.filter(that.inDrugItems, d => d.item_name),
                    (d, index) => {
                        return {
                            ...d,
                            biz_nursing_record_id: that.recordInfo.id,
                            item_type: `入量-临床用药`,
                            display_order: index + 1
                        }
                    }
                ) || []
                that.recordInfo.inOtherItems = _.map(
                    _.filter(that.inOtherItems, d => d.item_name),
                    (d, index) => {
                        return {
                            ...d,
                            biz_nursing_record_id: that.recordInfo.id,
                            item_type: `入量-胃肠`,
                            display_order: index + 1
                        }
                    }
                ) || []
                that.recordInfo.outItems = _.map(
                    _.filter(that.outItems, d => d.item_name),
                    (d, index) => {
                        return {
                            ...d,
                            biz_nursing_record_id: that.recordInfo.id,
                            item_type: `出量`,
                            display_order: index + 1
                        }
                    }
                ) || []
                that.recordInfo.biz_surgery_info_id = that.surgeryId
                that.myaxios[that.recordInfo.id > 0 ? `put` : `post`](`/api/Nursing/NursingRecord/${that.recordInfo.id > 0 ? `Put` : `Post`}`, that.recordInfo)
                    .then(data => {
                        that.$message.success(`保存成功`)
                        that.recordInfo = { biz_surgery_info_id: that.surgeryId }
                        if (!that.continueAdd || that.recordId) {
                            that.visibleSync = false
                        } else {
                            that.visibleSync = true
                            that.loadOne()
                        }
                        that.$emit(`save-success`)
                        resolve(that.recordInfo)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.el-divider__text {
    position: absolute !important;
    background-color: #F0F2F5 !important;
    padding: 0 10px !important;
    color: #303133 !important;
}
/deep/.cus-form .el-form-item.left .el-form-item__label {
    width: 85px !important;
}
/deep/.cus-form .el-form-item.left .el-form-item__content {
    margin-left: 85px !important;
}
/deep/.el-main {
    padding: 0px 5px 0px 10px !important;
}
/deep/.el-collapse-item__header {
    height: 25px !important;
    line-height: 25px !important;
    background-color: #D3D3D3 !important;
    padding-left: 15px !important;
}
/deep/.el-table .el-table__cell{
    padding: 0px !important;
}
/deep/.el-collapse-item__content{
    padding-bottom: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/NursingRecord/AddRecord.vue